import * as ds from '#brand/design-system'

export default {
  ds
}
